import { format, parseISO } from 'date-fns';
import { cs } from 'date-fns/locale';

export const humanDate = (date: string | Date) => {
	const parsed = typeof date === 'string' ? parseISO(date) : date;

	return `${format(parsed, 'dd.LL.yyyy', { locale: cs })}`;
};

export const humanTime = (date: string | Date) => {
	const parsed = typeof date === 'string' ? parseISO(date) : date;

	return `${format(parsed, 'HH:mm', { locale: cs })}`;
};

export const humanDateWithTime = (date: string | Date) => {
	const parsed = typeof date === 'string' ? parseISO(date) : date;

	return `${format(parsed, 'dd.LL.yyyy HH:mm', { locale: cs })}`;
};
